export class ClientStock {
    clientId: number;
    gencode: string;
    soh: number;
}

export class ClientStockRequest {
    gencode: string;
    tyreBrandIds: number[] = [];
    stock: ClientStock[];
}

export class StockBase {
    soh: number;
    description: string;
    stockCode: string;
    price: number;
    cost: number;
}

export class StockItem extends StockBase {
    msfId: number;
    genCode: string;
    tyreBrandId: number;
    tyreBrand: string;
    tyreLocationId: number;
}

export class StockCustomItem extends StockBase {
    stockCustomId: number;
    stockCustomDefaultId?: number;
}

export class StockList {
    stockItems: StockItem[] = [];
    stockCustomItems: StockCustomItem[] = [];
}
 
export class StockGroup {
    stockGroupId: number;
    stockGroupName: string;
    stockGroupTypeId: number;
    stockItems: StockCustomItem[] = [];
}
